"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutDesktop = void 0;
const tmpls_1 = require("./tmpls");
class LayoutDesktop extends tmpls_1.LayoutDesktopBase {
    // private _defaultUserImg:string="";
    // private _initedMap:boolean=false;
    constructor() {
        super();
        // this._defaultUserImg=this.ctrls.blockNavigation.ctrls.imgUserPhoto.src;
        // this.ctrls.blockTicketsControl.hide();
        // const navCtrls=this.ctrls.blockNavigation.ctrls;
        // navCtrls.folderParner.hide();
        // navCtrls.btnLogOut.onclick=()=>App.Inst.auth.dropAuthStateAsync();
        // navCtrls.btnSetting.onclick=()=>gs.StateGS.Run(StateMyProfileEdit);
        // navCtrls.btnLocalEn.onclick=()=>App.Inst.auth.setLangAsync(LanguageEnum.En);
        // navCtrls.btnLocalRu.onclick=()=>App.Inst.auth.setLangAsync(LanguageEnum.Ru);
    }
}
exports.LayoutDesktop = LayoutDesktop;
//# sourceMappingURL=LayoutDesktop.js.map